import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { updateJsonData } from "../../store/jsonSlice";
import { updateJsonDataLearn } from "../../store/jsonSliceLearn";

const ImportJsonButton = ({ type="work", onImportSuccess }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [importError, setImportError] = useState(null);

  const handleImportJson = (files) => {
    setImportError(null);
    if (!files || files.length === 0) return;
    const file = files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target.result);
        if(type === "work") {
          dispatch(updateJsonData(json));
        } else {
          dispatch(updateJsonDataLearn(json));
        } 
        if (onImportSuccess) onImportSuccess(json, file.name);
      } catch (err) {
        setImportError("Le fichier sélectionné n'est pas un JSON valide.");
      }
    };
    reader.onerror = () => setImportError("Erreur lors de la lecture du fichier.");
    reader.readAsText(file);
  };

  return (
    <div>
      <input
        type="file"
        id="import-json-input"
        accept="application/json"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={e => handleImportJson(e.target.files)}
      />
      <button
        className="btn btn-sm btn-outline-primary mx-2"
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
      >
        <i className=" dripicons-download align-middle"></i> Importer un JSON
      </button>
      {importError && <div className="alert alert-danger mt-2">{importError}</div>}
    </div>
  );
};

export default ImportJsonButton;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license